import React from 'react'

const PlayCircleIcon = ({length, click}) => {
  return (
    <svg
    onClick={click}
    width={length}
    height={length}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.33337 50C8.33337 26.9881 26.9882 8.33333 50 8.33333C73.0117 8.33333 91.6667 26.9881 91.6667 50C91.6667 73.0117 73.0117 91.6667 50 91.6667C26.9882 91.6667 8.33337 73.0117 8.33337 50ZM45.2317 33.9791C41.7605 32.0564 37.5 34.567 37.5 38.5353V61.465C37.5 65.4333 41.7605 67.9438 45.2317 66.0213L69.2225 52.7337C70.2167 52.1833 70.8334 51.1362 70.8334 50C70.8334 48.8637 70.2167 47.8171 69.2225 47.2662L45.2317 33.9791Z"
      fill="#BDBDBD"
    />
  </svg>
  )
}

export default PlayCircleIcon